
import { updateProduct } from '@/lib/supabase/products';
import { adjustProductStock } from '@/lib/supabase/inventory';
import type { SaveResult } from './types';
import type { Product } from '@/lib/supabase/products/types';

// Define and export the function in one step (no redeclaration)
export async function updateExistingProduct(
  productId: string,
  productData: Partial<Product>,
  initialQuantity: number,
  newQuantity: number
): Promise<SaveResult> {
  try {
    // Extract the stock_quantity to handle separately
    const { stock_quantity, ...productDataWithoutStock } = productData;
    
    console.log("Mise à jour du produit:", productId);
    
    // First update the product data itself (minus stock)
    const updatedProduct = await updateProduct(productId, productDataWithoutStock);
    
    if (!updatedProduct) {
      throw new Error('Erreur lors de la mise à jour du produit');
    }
    
    // If stock management is enabled, handle stock updates if quantity changed
    if (productData.is_stock_managed && initialQuantity !== newQuantity) {
      console.log(`Mise à jour du stock: ${initialQuantity} -> ${newQuantity}`);
      
      // Calculate adjustment amount
      const adjustmentAmount = newQuantity - initialQuantity;
      
      if (adjustmentAmount !== 0) {
        const adjustmentType = adjustmentAmount > 0 ? 'add' : 'remove';
        const absAdjustment = Math.abs(adjustmentAmount);
        
        // Log the stock adjustment being made
        console.log(`Ajustement de stock: ${adjustmentType} ${absAdjustment}`);
        
        // Apply the stock adjustment using the inventory service
        await adjustProductStock({
          productId,
          quantityChange: adjustmentAmount,
          reason: 'Ajustement manuel via formulaire',
          notes: `Modification de ${initialQuantity} à ${newQuantity}`
        });
      }
    }
    
    return { success: true, productId };
  } catch (error) {
    console.error("Erreur lors de la mise à jour du produit:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error : new Error('Erreur inconnue') 
    };
  }
}
